(function($) {
	function crfImplementationMaturity(categorizedScoresObj) {
		// Extract the cleaned categorized scores from the object returned by calculateMaturityScoresByLevelPerCategory
		const categorizedScores = categorizedScoresObj.cleanedCategorizedScores || categorizedScoresObj;

		console.log('[crfImplementationMaturity] DEBUGGING: categorizedScores', (categorizedScores));
		const MaturityImplementationScores = categorizedScores; // Reference the input object for direct modification

		// Loop through each category
		Object.keys(MaturityImplementationScores).forEach(category => {
			let categoryTotalScore = 0;
			let categoryCount = 0;

			// Loop through each topic in the category
			Object.keys(MaturityImplementationScores[category]).forEach(topic => {
				const topicData = MaturityImplementationScores[category][topic];
				let topicTotalScore = 0;
				let topicCount = 0;

				// Loop through each level in the topic
				Object.keys(topicData).forEach(level => {
					if (level !== 'overallMaturityScore') {
						const levelData = topicData[level];
						// Calculate the average score, accounting for Not Applicable items
						let denominator = 0;

						// Use the same logic as calculateMaturityScoresByLevelPerCategory
						if (levelData.potentialCount && levelData.naItems) {
							// Newer data structure with potentialCount and naItems
							denominator = levelData.potentialCount - levelData.naItems.length;
						} else if (levelData.count !== undefined) {
							// Fallback to count, but this might include N/A items
							denominator = levelData.count;
							console.warn(`[crfImplementationMaturity] Using fallback count for ${category}.${topic}.${level}. This may include N/A items.`);
						}

						if (denominator > 0) {
							levelData.averageScore = levelData.totalScore / denominator;
						} else {
							levelData.averageScore = 0; // No applicable entries, so set average to 0
						}

						// Accumulate scores and counts for topic-level calculations
						// Use the same denominator for consistency
						topicTotalScore += levelData.totalScore;
						topicCount += denominator;
					}
				});

				// Calculate the overall maturity score for the topic
				if (topicCount > 0) {
					topicData.overallMaturityScore = topicTotalScore / topicCount;
				} else {
					topicData.overallMaturityScore = 0; // No entries, so set overall score to 0
				}

				// Accumulate scores and counts for category-level calculations
				categoryTotalScore += topicTotalScore;
				categoryCount += topicCount;
			});

			// Calculate the overall maturity score for the category
			if (categoryCount > 0) {
				MaturityImplementationScores[category].overallMaturityScore = categoryTotalScore / categoryCount;
			} else {
				MaturityImplementationScores[category].overallMaturityScore = 0; // No entries, so set overall score to 0
			}
		});
        
		console.log('[crfImplementationMaturity] MaturityImplementationScores', MaturityImplementationScores);
		return MaturityImplementationScores;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = crfImplementationMaturity;
	} else if (typeof window !== 'undefined') {
		window.crfImplementationMaturity = crfImplementationMaturity;
	}
})(jQuery);
